// extracted by mini-css-extract-plugin
export var buttonContainer = "_95-1";
export var fontSizeSelect = "_95-3";
export var formatSelect = "_95-2";
export var formats = "_95-4";
export var hidden = "_95-5";
export var icon = "_95-6";
export var select = "_95-0";